import OutboundInternalRequestsApiV2 from 'api/v2/admins/outbound-internal-requests-api-v2'
import TitlePage from 'components/atoms/title-page'
import InternalRequestDetail from 'domains/internal-request/organisms/internal-request-detail'
import InternalRequestItemTable from 'domains/internal-request/organisms/item-table'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import {
  Button, Card,
  CardBody, CardHeader,
  CardTitle
} from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const InternalRequestRequestorViewDetailPage = ({ pageUtils }) => {
  const [ internalRequest, setInternalRequest ] = useState({})
  const [ items, setItems ]                     = useState([])
  const [ pagination, setPagination ]           = useState({})
  const history                                 = useHistory()
  const { id }                                  = useParams()

  // Hide particular columns
  const hiddenColumns = [
    'size',
    'quantity_picked',
    'quantity_requested',
    'quantity_to_borrow',
    'quantity_in_warehouse',
    'quantity_put_away',
    'marked_for_return',
    'returned',
    'unreturned',
    'reject_reason',
    'reject_note',
    'location',
    'action'
  ]

  useEffect(() => {
    OutboundInternalRequestsApiV2.show(id)
      .then((response) => setInternalRequest(response.data.internal_request))
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils ])

  /** Fetching Internal Request Item */
  const handleFetchItems = useCallback((tableState) => {
    OutboundInternalRequestsApiV2.getItems({ internal_request_id: id, tableState: tableState })
      .then((response) => {
        setItems(response.data.internal_request_items)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ id, pageUtils ])

  useEffect(() => {
    handleFetchItems()
  }, [ handleFetchItems ])

  return (
    <>
      <TitlePage mainTitle='Internal Request' subTitle='View Only Detail' />

      <InternalRequestDetail internal_request={ internalRequest } />

      <Card>
        <CardHeader>
          <CardTitle>
            <h2>{ 'Borrowed Items' }</h2>
          </CardTitle>
          <Button
            color='info'
            onClick={ () => { history.goBack()} }
          >
            { 'Back' }
          </Button>
        </CardHeader>
        <CardBody>
          <InternalRequestItemTable
            data={ items }
            pagination={ pagination }
            onFetchData={ handleFetchItems }
            hiddenColumns={ hiddenColumns }
          />
        </CardBody>
      </Card>
    </>
  )
}

InternalRequestRequestorViewDetailPage.propTypes = propTypes

export default InternalRequestRequestorViewDetailPage
